// @flow
import * as React from 'react';
import {
  types as t,
  usePropsValidation,
} from '../../validation/runtime-checks/index.js';
import { productColorSunflower } from '../../designSystem.js';
import { stringWithConstraints } from '../../stringWithConstraintsMatcher.js';

export function RSLPriorKnowledgeLink(props: {|
  subtopicId: number,
  children: string,
|}) {
  const { failedValidation } = usePropsValidation(props, RSLPriorKnowledgeLink);
  if (failedValidation) return null;

  return (
    // This odd-looking wrapping span is so that content authors do not need
    // to be sophisticated in the use of {' '} in JSX in order to ensure
    // that here is a space before/after the <RSLPriorKnowledgeLink> component
    // and the surrounding text. Using this wrapping span approach should
    // hopefully also allow screen readers to read the paragraph correctly
    // (if we were producing the space using margins, for example, then the
    // adjacent text would be concatenated with the text in here, and so the
    // read-out text would be non-sensical).
    <span>
      {' '}
      <span
        style={{
          display: 'inline-block',
          color: productColorSunflower.eggplant,
          backgroundColor: productColorSunflower.eggplant10,
          borderRadius: 6,
          fontWeight: 600,
        }}
      >
        {/* We use &nbsp; rather than padding so that text selection looks good */}
        &nbsp;{props.children}&nbsp;
      </span>{' '}
    </span>
  );
}
RSLPriorKnowledgeLink.spec = {
  subtopicId: t.number,
  children: stringWithConstraints({
    mustContainNonWhitespaceChars: true,
    banLeadingAndTrailingWhitespace: true,
  }),
};
